module.exports = __webpack_public_path__ + "img/open.ecbe85e8.svg";